export default "__VITE_ASSET__BgYOFNDs__"